import React from "react";
import { Box, Container, Stack, Tabs, Tab, Button } from "@mui/material";
import Typography from "@mui/material/Typography";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import DescriptionIcon from "@mui/icons-material/Description";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import "../../../css/help.css";
import { faq } from "../../../lib/data/faq";
import { terms } from "../../../lib/data/terms";

export default function HelpPage() {
  const [value, setValue] = React.useState("1");

  const handleChange = (_e: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  return (
    <div className="help-page">
      <Box className="help-hero">
        <Container className="help-hero-container">
          <Box className="help-hero-content">
            <HelpOutlineIcon className="help-hero-icon" />
            <h1 className="help-hero-title">Help Center</h1>
            <p className="help-hero-subtitle">
              Find answers, terms, and get in touch with us.
            </p>
          </Box>
        </Container>
      </Box>

      <Container className="help-container">
        <TabContext value={value}>
          <Box className="help-tabs-wrap">
            <Tabs
              value={value}
              onChange={handleChange}
              className="help-tabs"
              variant="fullWidth"
            >
              <Tab
                icon={<DescriptionIcon />}
                iconPosition="start"
                label="Terms"
                value="1"
              />
              <Tab
                icon={<HelpOutlineIcon />}
                iconPosition="start"
                label="FAQ"
                value="2"
              />
              <Tab
                icon={<ContactMailIcon />}
                iconPosition="start"
                label="Contact"
                value="3"
              />
            </Tabs>
          </Box>

          <Stack className="help-content">
            <TabPanel value="1">
              <Box className="help-card help-terms-card">
                <h2 className="help-section-title">Terms of Use</h2>
                <ul className="help-terms-list">
                  {terms.map((text, i) => (
                    <li key={i} className="help-terms-item">
                      <span className="help-terms-num">{i + 1}</span>
                      <span>{text}</span>
                    </li>
                  ))}
                </ul>
              </Box>
            </TabPanel>

            <TabPanel value="2">
              <Box className="help-card help-faq-card">
                <h2 className="help-section-title">Frequently Asked Questions</h2>
                <Stack className="help-accordion-stack">
                  {faq.map((item, i) => (
                    <Accordion key={i} className="help-accordion">
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        className="help-accordion-summary"
                      >
                        <Typography className="help-accordion-question">
                          {item.question}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails className="help-accordion-details">
                        <Typography className="help-accordion-answer">
                          {item.answer}
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  ))}
                </Stack>
              </Box>
            </TabPanel>

            <TabPanel value="3">
              <Box className="help-card help-contact-card">
                <h2 className="help-section-title">Contact us</h2>
                <p className="help-contact-intro">
                  Fill out the form below and we’ll get back to you as soon as we can.
                </p>
                <form className="help-contact-form" action="#" method="POST">
                  <div className="help-form-field">
                    <label htmlFor="help-name">Your name</label>
                    <input
                      id="help-name"
                      type="text"
                      name="memberNick"
                      placeholder="Type your name here"
                    />
                  </div>
                  <div className="help-form-field">
                    <label htmlFor="help-email">Your email</label>
                    <input
                      id="help-email"
                      type="email"
                      name="memberEmail"
                      placeholder="Type your email here"
                    />
                  </div>
                  <div className="help-form-field">
                    <label htmlFor="help-message">Message</label>
                    <textarea
                      id="help-message"
                      name="memberMsg"
                      placeholder="Your message"
                      rows={5}
                    />
                  </div>
                  <Button type="submit" variant="contained" className="help-submit-btn">
                    Send message
                  </Button>
                </form>
              </Box>
            </TabPanel>
          </Stack>
        </TabContext>
      </Container>
    </div>
  );
}
